module.exports = __webpack_public_path__ + "img/icon-restaurant-pos-before.0f8b6b47.png";